<script>
  import { onMount } from 'svelte'

  import userStore from '../stores/user.js'

  import PageMain from './page-main.svelte'
  import QueueAdd from './queue-add.svelte'


  let subView = false
  const closeSubView = function () {
    subView = false
  }
  const addQueue = function () {
    subView = 'add'
  }
  const queueAdded = function () {
    userStore.refresh()
      .then(() => {
        subView = false
      })
  }

  $: queues = $userStore && $userStore.queues.filter(q => q.status === 'current')

  onMount(() => {
    userStore.maybeInit()
  })
</script>

{#if subView === 'add'}
  <QueueAdd on:added={queueAdded} on:back={closeSubView} />
{:else}
  <PageMain currentView="queues" title="Queues">
    {#if queues === undefined}
      <div class="noticeWrapper">
        <div class="notice">Loading...</div>
      </div>
    {:else if queues.length === 0}
      <div class="noticeWrapper">
        <div class="notice">
          <p>Queues are ordered collections of tasks you want to complete.</p>
          <p>Add a queue below to get started.</p>
        </div>
      </div>
    {:else}
      <div class="listWrapper scrollBlock">
        <div class="queueList">
          {#each queues as queue (queue.queue_id)}
            <a class="queueEntry greyLink" href="#{queue.queue_id}" title={queue.name}>
              {queue.name}
            </a>
          {/each}
        </div>
      </div>
    {/if}
    <div slot="controls" class="controls">
      <button class="mainButton" on:click={addQueue}>Add Queue</button>
    </div>
  </PageMain>
{/if}

<style>
  .listWrapper {
    display: flex;
    flex-direction: column;

    border-top: 1px solid var(--border-color);
    border-bottom: 1px solid var(--border-color);
  }
  .queueList {
    flex-grow: 1;

    display: flex;
    flex-direction: column;
    justify-content: center;

    padding: 5px;
  }
  .queueList .queueEntry {
    padding: 20px;

    background-color: white;
    border: 1px solid var(--border-color);
    border-bottom-width: 0;
    border-radius: 0;

    text-align: center;
    font-size: 1.2em;
    font-weight: 400;
    overflow-wrap: anywhere;
  }
  .queueList > .queueEntry:first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .queueList > .queueEntry:last-child {
    border-bottom-width: 1px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
</style>
